export default __webpack_public_path__ + "static/process6-bad24dc6e90b6ee3d4b80baaf27adc2c.png";